module.exports = "/_next/static/images/icon__check-829179283e000cf51d37e0179dbf229d.png";